import React from 'react';
import { TEMPLATE_CATEGORIES, ALL_TEMPLATE_IDS } from '../../../templates/templateDesignSystem';

export default function CategoryTabs({ activeCategory, setActiveCategory, favoritesCount = 0, T }) {
  const TABS = [
    { id: 'all', label: 'All', count: ALL_TEMPLATE_IDS.length, color: 'var(--brand)' },
    ...(favoritesCount > 0 ? [{ id: 'favorites', label: 'Favorites', count: favoritesCount, color: '#ef4444' }] : []),
    ...TEMPLATE_CATEGORIES.map(cat => ({
      id: cat.id,
      label: cat.label.replace(' Collection', ''),
      count: cat.templates.length,
      color: cat.badgeColor
    }))
  ];

  return (
    <div style={{ display: 'flex', gap: 2, overflowX: 'auto', borderBottom: `1px solid ${T.borderMain}` }}>
      {TABS.map(tab => {
        const isActive = activeCategory === tab.id;
        return (
          <button
            key={tab.id}
            className="tg-tab"
            onClick={() => setActiveCategory(tab.id)}
            style={{
              padding: '8px 12px',
              borderRadius: '8px 8px 0 0',
              cursor: 'pointer',
              whiteSpace: 'nowrap',
              fontSize: '10px',
              fontWeight: 700,
              border: 'none',
              background: isActive ? T.tabActiveBg : 'transparent',
              color: isActive ? (tab.color || T.textPrimary) : T.textTab,
              borderBottom: isActive ? `2px solid ${tab.color || T.textPrimary}` : '2px solid transparent',
              display: 'flex',
              alignItems: 'center',
              gap: 4
            }}
          >
            <span>{tab.label}</span>
            <span style={{
              fontSize: '7.5px',
              padding: '1px 5px',
              borderRadius: 10,
              fontWeight: 800,
              background: isActive ? (tab.color ? `${tab.color}18` : T.pillBg) : T.pillBg,
              color: isActive ? (tab.color || T.textSecondary) : T.textMuted,
            }}>{tab.count}</span>
          </button>
        );
      })}
    </div>
  );
}
